import "./standardPlaceholder.css";
import useIsMobile from "components/useIsMobile";
import { BrowserRouter, Routes, Route, Link, useNavigate, Navigate } from "react-router-dom";

function StandardPlaceholder({
  src,
  srcMob,
  link,
  linkMob,
  src2,
  link2,
  routerLink,
  settings,
}: any) {
  const { dskSplit  }: any = settings || {};
  const isMobile: boolean = useIsMobile();

  const splitForDsk = !isMobile && dskSplit;

  const trueSrc = isMobile ? srcMob || src : src;
  return (
    <div
      className={`standard_placeholder_container ${splitForDsk ? "split" : ""}`}
    >
    {!routerLink ? (<a
        href={link}
        className={`${splitForDsk ? "split" : ""}`}
        target="_blank"
        rel="noreferrer"
      >
        <img src={trueSrc} alt="navigation" />
      </a>) : (<Link to={routerLink}><img src={trueSrc} alt="navigation" /></Link>)}
      {src2 && (
        <a href={link2} className="split" target="_blank" rel="noreferrer">
          <img src={src2} alt="navigation" />
        </a>
      )}
    </div>
  );
}

export default StandardPlaceholder;
